import(/* webpackMode: "eager", webpackExports: ["Spin"] */ "__barrel_optimize__?names=Spin!=!/vercel/path0/node_modules/antd/es/index.js");
